import { router } from 'src';

import { CreateOrderResponse } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { NavigationService } from 'src/services/navigation-service';
import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { selectSelectedProductOrThrow } from 'src/state/order/selectors';
import { createAppAsyncThunk } from 'src/state/thunk-api';
import { handleError } from 'src/utils/error-utils';

export const createOrderActionCreator = createAppAsyncThunk<CreateOrderResponse>(
  'order/createOrder',
  async (_, { getState }) => {
    const account = selectSelectedAccountOrThrow(getState());
    const serviceLocation = selectSelectedServiceLocationOrThrow(getState());
    const selectedProduct = selectSelectedProductOrThrow(getState());
    const { partnerId, customerId } = account;
    const { integrationId } = serviceLocation;

    router.navigate(NavigationService.SUCCESS, { replace: true });

    try {
      return await api.orderController.createOrder(partnerId, {
        billingAccountId: customerId,
        servicePointId: integrationId,
        productKey: selectedProduct.key,
      });
    } catch (error) {
      handleError(error);
      return Promise.reject(error);
    }
  },
);
